module.exports = __webpack_public_path__ + "img/20210801_133033.6184e188.jpg";